<template>
  <div class="d-none d-sm-block left-panel ">
      <div class="left-panel-bg">
        <img src="@/assets/imgs/corporate-businessmen-working-tablet-office.png"/>
      </div>
      <div class="wrapper text-right">
          <div><img @click="$router.push({ name: 'home' })" src="~@/assets/imgs/logo_dark.png" title="Ir para página inicial..." class="logo" /></div>
          <h1 class="mb-4">No portal do <b>IEPTB-BR</b><br>
          você pode contar com<br>
          diversos serviços prestados<br>
          pelos <b>Cartórios de Protestos</b><br>
          de todo Brasil!</h1>
            <!-- <h1>Você sabia que os serviços de envio gratuito<br> de títulos a protesto, pedidos de certidão, emissão de</h1> 
            <h1>anuência eletrônica e autorizações de cancelamento de</h1> 
            <h1>protesto agora estão todos online?</h1> -->
          <div class="bg-blue-text">
            <h2>Ganhe tempo. Faça seu cadastro.</h2>
          </div>
          <div class="bg-blue-text mb-4">
            <h2>Aproveite nossos serviços sem sair de casa!</h2>
          </div>
          <h1>Caso já tenha efetuado o cadastro, basta <br> acessar o sistema com seu <b>login e senha</b>, ou <br><b>certificado digital.</b></h1>
          <h1>Ah, e você também consegue visualizar <br>o <b>Instrumento de Protesto</b> por aqui.</h1> 
      </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
  .logo {
    cursor: pointer;
    margin-bottom: 20px;
    height: auto;
  }
  .left-panel {
    position: absolute;
    left: 0%;
    width: 50%;
    height: 100%;
    /* background-image: url("~@/assets/imgs/corporate-businessmen-working-tablet-office.png") !important;
    background-repeat: no-repeat;
    background-size: cover; */
  }
  .left-panel-bg{
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    background: -webkit-gradient(linear, left top, left bottom, from(#1ACEB5), to(#4780F1)) 0% 0% no-repeat padding-box;
    background: linear-gradient(180deg, #1ACEB5 0%, #4780F1 100%) 0% 0% no-repeat padding-box;
  }
  .left-panel-bg img{
    width: 100%;
    height: 100%;
    mix-blend-mode: multiply;
    -o-object-fit: cover;
    object-fit: cover;
  }
  .left-panel .wrapper {
    text-align: center !important;
    margin: 6% 0 0 0;
    z-index: 2;
    position: relative;
    float:right;
    margin-right: 64px;
    display: flex;
    align-items: end;
    flex-flow: column;
    user-select: none;
  }
  .left-panel .wrapper .bg-blue-text {
    background: var(--primary-color) 0% 0% no-repeat padding-box;
    padding: 7.5px 6px;
    margin-bottom: 6px;
    width: fit-content;
    justify-self: right;
  }
  .left-panel .wrapper h1 {
    text-align: right;
    letter-spacing: 0px;
    color: #FFFFFF !important;
    font: normal normal normal 25px/41px 'Kanit', sans-serif;
    font-weight: 100;
    margin-right: 6px;
    /* max-width: 200px; */
  }
  .left-panel .wrapper h2 {
    margin:0;
    text-align: right;
    font: normal normal normal 18px/20px 'Kanit', sans-serif;
    font-weight: 200;
    letter-spacing: 0px;
    color: #FFFFFF !important;
  }
  @media (max-width: 1200px){
    .left-panel .wrapper{
      margin-right: 6%;
    }
    .left-panel .wrapper h1{
      font-size: 17px;
      line-height: 28px;
    }
    .left-panel .wrapper h2{
      font-size: 15px;
      line-height: 17px;
    }
  }
  @media (min-width: 360px) and (max-width:800px){
    /* .logo {
      height: 50px;
    } */
    /* .left-panel .wrapper h2{
      font-size: 20px !important;
    }
    img{
      max-width: 180px !important;
    } */
    .right-panel {
      width: 100% !important;
    }
  }
  @media  (max-width:1500px){
    h2, .h2 {
      font-size: 20px;
    }
  }
  @media (max-width: 780px){
    .left-panel{display: none !important;}
  }
</style>
